export default "__VITE_ASSET__FZ8dfItp__"